import type { BoardDevice, FindRoomSwitches } from "./types";

// A switch hangs by the door of the room it switches; one farther than this from every light switches none of them.
const SWITCH_REACH_M = 8;

const distance = (a: BoardDevice, b: BoardDevice): number =>
  Math.hypot(a.position.x - b.position.x, a.position.y - b.position.y);

export const findRoomSwitches: FindRoomSwitches = ({ circuitId, boardDevices, pointsPerMetre }) => {
  const lights = boardDevices.filter((device) => !device.isControl);
  if (!lights.some((light) => light.circuitId === circuitId)) return [];
  const reach = SWITCH_REACH_M * pointsPerMetre;

  return boardDevices.filter((device) => {
    if (!device.isControl || device.circuitId === circuitId) return false;
    const nearest = lights.reduce<BoardDevice | null>(
      (best, light) => (!best || distance(device, light) < distance(device, best) ? light : best),
      null,
    );
    return nearest !== null && nearest.circuitId === circuitId && (!reach || distance(device, nearest) <= reach);
  });
};
